import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api/api.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {
  public location: any;

  constructor(private api: ApiService, private route: ActivatedRoute) {}

  ngOnInit() {
    // this.getLocation();
  }

  getLocation(): any {
    // let name = this.route.snapshot.paramMap.get('name');
    // this.api.location.get(name).subscribe(result => {
    //   this.location = result;
    // });
  }
}
